module.exports = __webpack_public_path__ + "static/logo-fcbfc62b1bf1e8f68ba43aa50c5d6e6d.png";